module.exports = __webpack_public_path__ + "static/img/model1@2x.e114e62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/model1@2x.png
// module id = 3FBX
// module chunks = 1